import { useMutation, useQuery, useQueryClient } from 'react-query'
import { CustomerMarketingPreferencesApi } from '@trybeapp/sdk.customer'
import { ApiResponse } from '@trybeapp/sdk'
import { LegacySdkResponseError } from 'api/api.types'

const api = new CustomerMarketingPreferencesApi()

export const useCustomerMarketingPreferences = (customerId: string, params = {}) =>
  useQuery(['customerMarketingPreferences', { params }], async () =>
    api.listCustomerMarketingPreferences(customerId, params)
  )

export const useOptIn = (customerId: string) => {
  const queryClient = useQueryClient()

  return useMutation<ApiResponse<any>, LegacySdkResponseError, string>(
    async (preferenceId) => api.marketingPreferenceOptIn(customerId, preferenceId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customerMarketingPreferences')
      },
    }
  )
}

export const useOptOut = (customerId: string) => {
  const queryClient = useQueryClient()

  return useMutation<ApiResponse<any>, LegacySdkResponseError, string>(
    async (preferenceId) => api.marketingPreferenceOptOut(customerId, preferenceId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('customerMarketingPreferences')
      },
    }
  )
}
